import { render } from "./WithdrawSaldoPage.vue?vue&type=template&id=097967c2&scoped=true"
import script from "./WithdrawSaldoPage.vue?vue&type=script&lang=js"
export * from "./WithdrawSaldoPage.vue?vue&type=script&lang=js"

import "./WithdrawSaldoPage.vue?vue&type=style&index=0&id=097967c2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-097967c2"]])

export default __exports__